let regId = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
let email = /^(\w+\.?)*\w+@(?:\w+\.)\w+$/ //邮箱
let phone = /(^([0-9]{3,4}-)?[0-9]{7,8}$)|(^((\+?86)|(\(\+86\)))?(13[012356789][0-9]{8}|15[012356789][0-9]{8}|18[02356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$)/ //手机号码 与 固话
let fax = /^(\d{3,4}-)?\d{7,8}$/ //传真
let name = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,10}$/; //姓名
let FormValidate = (function() {
    // eslint-disable-next-line
    function FormValidate() {}
    // From表单验证规则  可用于公用的校验部分
    FormValidate.Form = function() {
        return {
            // 姓名的验证规则
            Name: function(rule, value, callback) {
                if (!value) {
                    return callback(new Error('姓名不能为空'))
                }
                if (!name.test(value)) {
                    callback(new Error('请输入正确姓名!'))
                } else {
                    callback()
                }
            },
            // 邮箱的正则
            email: function(rule, value, callback) {
                if (value == '') {
                    callback()
                }
                if (!email.test(value)) {
                    callback(new Error('请输入正确的邮箱!'))
                } else {
                    callback()
                }
            },
            // 身份证的验证规则
            ID: function(rule, value, callback) {
                if (!value) {
                    return callback(new Error('身份证不能为空'))
                }
                if (!regId.test(value)) {
                    callback(new Error('请输入正确的二代身份证号码'))
                } else {
                    callback()
                }
            },
            // 电话号码的验证
            phone: (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('電話不能為空'))
                }
                if (!phone.test(value)) {
                    callback(new Error('請正確填寫電話，固话请加上区号 如852-'))
                } else {
                    callback()
                }
            }
        }
    }

    // FromOne表单验证规则  用于FromOne个性化的校验
    FormValidate.FormOne = function() {
        return {
            // 姓名的验证规则
            Name: function(rule, value, callback) {
                if (!value) {
                    return callback(new Error('姓名不能为空'))
                }
                if (!name.test(value)) {
                    callback(new Error('请输入正确姓名!'))
                } else {
                    callback()
                }
            }
        }
    }
    return FormValidate
}())
exports.FormValidate = FormValidate


// WEBPACK FOOTER //
// ./src/components/Format.js